import { i18next } from '@frontend/i18n';
import { IconName } from '@frontend/icons';

export enum PurchaseDeviceType {
  PAYMENT_TERMINAL = 'payment-terminal',
  DESK_PHONE = 'desk-phone',
}

export const PurchaseDeviceTypeLinksMap: Record<PurchaseDeviceType, string> = {
  [PurchaseDeviceType.PAYMENT_TERMINAL]: 'https://www.getweave.com/demo/campaign/payment-terminal/?utm_source=product',
  [PurchaseDeviceType.DESK_PHONE]: 'https://www.getweave.com/demo/campaign/additional-phone/?utm_source=product',
};

export const PurchaseDeviceTypeCFMap: Record<PurchaseDeviceType, string> = {
  [PurchaseDeviceType.PAYMENT_TERMINAL]: 'paymentterminals',
  [PurchaseDeviceType.DESK_PHONE]: 'phonehomeicon',
};

export const PurchaseDeviceTypeFFMap: Record<PurchaseDeviceType, string> = {
  [PurchaseDeviceType.PAYMENT_TERMINAL]: 'purchase-devices:payment-terminal:show-action',
  [PurchaseDeviceType.DESK_PHONE]: 'purchase-devices:desk-phone:show-action',
};

export const PurchaseDeviceTypeDisplayValuesMap: Record<PurchaseDeviceType, { label: string; icon: IconName }> = {
  [PurchaseDeviceType.PAYMENT_TERMINAL]: {
    label: i18next.t('Purchase Payments Terminal', { ns: 'purchaseDevices' }),
    icon: 'payments',
  },
  [PurchaseDeviceType.DESK_PHONE]: {
    label: i18next.t('Purchase Desk Phone', { ns: 'purchaseDevices' }),
    icon: 'phone',
  },
};
